import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Card from '../../shared/Card';
import { Alpha, Beta } from '../../shared/icons';

const Games = () => {
  return (
    <Card>
      <div className="games-container">
        <h1>Games</h1>
        <section className="mb-4">
          <h2>Single Player</h2>
          <ul className="list-unstyled">
            <li>
              <Link to="/chiv">Chiv Chess</Link>
              <Beta />
            </li>
            <li>
              <Link to="/fight-sim">Fight Sim</Link>
              <Alpha />
            </li>
            <li>
              <Link to="/incremental-clicker-game">Incremental Clicker</Link>
              <Beta />
            </li>
            <li>
              <Link to="/simcity">Sim City</Link>
              <Beta />
            </li>
            <li>
              <Link to="/time-balls">Time Balls</Link>
              <Alpha />
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h2>Multiplayer</h2>
          <ul className="list-unstyled">
            <li>
              <Link to="/hextones">HexTones</Link>
              <Beta />
            </li>
            <li>
              <Link to="/chess">Chess</Link>
              <Alpha />
            </li>
            <li>
              {/* TODO make more prominent */}
              <Link to="/cultivation">Cultivation</Link>
              <Beta />
            </li>
            <li>
              <Link to="/tictactoe">Tic-Tac-Toe</Link>
              <Alpha />
            </li>
          </ul>
        </section>

        <section>
          <h2>External</h2>
          <ul className="list-unstyled">
            <li>
              <a
                href="https://cluesweeper.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Clue Sweeper
                <FontAwesomeIcon
                  icon={faExternalLinkAlt}
                  style={{ fontSize: '80%', marginLeft: '0.4rem' }}
                />
              </a>
              {' '}— Codenames-style team word game
            </li>
          </ul>
        </section>
      </div>
    </Card>
  );
};

export default Games;
